<template>
  <div class="login__box">
    <div class="login__box__welcome">
      <div class="login__box__welcome__top">Adgame</div>
      <div class="login__box__welcome__bottom">Password reset</div>
    </div>

    <div>
      <div class="login__box__input-description">New password</div>
      <input
        type="password"
        class="login__box__input-password"
        placeholder="password"
        v-model="form.password"
      />

      <div class="login__box__input-description">New password again</div>
      <input
        type="password"
        class="login__box__input-password"
        placeholder="password again"
        v-model="form.confirmPassword"
      />

      <div class="register__box__register">
        <button @click="submitForm()" class="button">Change password</button>
      </div>

      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "passwordResetBox",
  data() {
    return {
      form: {
        password: "",
        confirmPassword: "",
        passwordResetToken: this.$route.query.token,
      },
    };
  },
  methods: {
    ...mapActions({
      changePasswordReset: "changePasswordReset",
    }),

    checkEmptyForm() {
      if (this.form.password == "" || this.form.confirmPassword == "") {
        this.$toast.error(
          this.$t("messages.user-account.password-reset-empty-fields")
        );
        this.form.password = "";
        this.form.confirmPassword = "";
        return false;
      }
      return true;
    },

    checkPasswords() {
      if (this.form.password != this.form.confirmPassword) {
        this.$toast.error(
          this.$t("messages.user-account.password-reset-different-passwords")
        );
        this.form.password = "";
        this.form.confirmPassword = "";
        return false;
      }
      return true;
    },

    async submitForm() {
      if (!this.checkEmptyForm() || !this.checkPasswords()) return false;

      await this.$store.dispatch("toggleLoader", true);

      try {
        await this.changePasswordReset(this.form);
        this.$toast.success(
          this.$t("messages.user-account.password-reset-success")
        );
        this.$router.push({ name: "Login" });
      } catch (e) {
        if (e.response.data.msg == "user-mng.pwd-policy-error") {
          this.$toast.error(
            this.$t("messages.user-account.password-reset-pwd-policy")
          );
        } else if (e.response.data.msg == "user-mng.reset-pwd.pwd-no-change") {
          this.$toast.error(
            this.$t("messages.user-account.password-reset-pwd-no-change")
          );
        } else {
          this.$toast.error(
            this.$t("messages.user-account.password-reset-response", { msg: e })
          );
          this.form.password = "";
          this.form.confirmPassword = "";
        }
      }
      await this.$store.dispatch("toggleLoader", false);
    },
  },
};
</script>

<style>
</style>
